import {
  getSPDataWithParams,
  postSPDataWithoutParams,
} from './services'

const BASE = '/api/secure/cc/support/clinic-brand/comms-config'

export async function getSupportClinicBrandCommsConfig(clinicBrandId) {
  if (!clinicBrandId) {
    throw new Error('clinicBrandId is required')
  }
  return getSPDataWithParams(`${BASE}/current`, { clinicBrandId })
}

export async function getSupportClinicBrandCommsProfile(clinicBrandId) {
  if (!clinicBrandId) {
    throw new Error('clinicBrandId is required')
  }
  return getSPDataWithParams(`${BASE}/profile`, { clinicBrandId })
}

export async function getSupportPatientCommunicationPolicyOptions() {
  return getSPDataWithParams(`${BASE}/policy/options`, {})
}

export async function saveSupportPatientCommunicationPolicy(payload) {
  return postSPDataWithoutParams(`${BASE}/policy`, payload)
}
